import React from "react";

/**
 * Nhãn "Disputed" (17/10/2026) — khách đang/đã khiếu nại đòi tiền qua ngân hàng hoặc PayPal.
 * Dữ liệu từ GET /admin/order-disputes (backend modules/dispute). Đây là LỚP PHỦ, trạng thái
 * đơn bên dưới giữ nguyên; trong lúc tranh chấp không huỷ/hoàn/sửa tay được.
 */
export type OrderDisputeOverlay = {
	label: string | null;
	phase: string;
	gateway: string;
	amount: number | null;
	currency: string | null;
	dueBy: string | null;
	/** Thua mà đơn đã trả trạm (lệnh cũ) ⇒ Admin hiện nút "Chargeback settled…". */
	needsChargebackSettle?: boolean;
};

const PHASE_TEXT: Record<string, string> = {
	open: "Dispute open — waiting for the card issuer / PayPal",
	lost: "Dispute lost — the customer got the money back through the bank / PayPal",
	pending_ledger: "Buyer won — waiting for PayPal's ledger to confirm who pays",
};

export default function DisputedBadge(props: { dispute?: OrderDisputeOverlay | null }) {
	const d = props.dispute;
	if (!d || !d.label) return null;
	const gateway = d.gateway === "paypal" ? "PayPal" : "Stripe";
	const amount = d.amount != null ? ` · ${d.amount} ${d.currency || ""}` : "";
	const due = d.dueBy ? ` · due ${d.dueBy}` : "";
	return (
		<div
			title={`${PHASE_TEXT[d.phase] || "Payment dispute"} (${gateway}${amount}${due}). Cancel, refund and status edits are blocked until it is resolved.`}
			style={{
				display: "inline-block",
				marginTop: 6,
				padding: "2px 8px",
				borderRadius: 999,
				fontSize: 12,
				fontWeight: 700,
				color: "#9F1239",
				background: "#FFE4E6",
				border: "1px solid #FDA4AF",
				whiteSpace: "nowrap",
			}}>
			{d.label}
			{d.dueBy ? ` · due ${d.dueBy}` : ""}
		</div>
	);
}
